module.exports = __webpack_public_path__ + "static/media/fushifaru_main_logo.97dc0fc0.svg";